import React from 'react'
import {connect} from 'react-redux'
import Report from '../classes/report'
import {storeHistorySelection, setHistoryData} from "../state/actions/app"

const mapStateAsProps = (state) => ({
    historyData: state.historyData,
    report: state.projectInfo.report,
    pid: state.projectInfo.urlParams.pid
})
const mapDispatchAsProps = dispatch =>({
    setHistoryData: (data) => dispatch(setHistoryData(data)),
    storeSelection: (selection)=> dispatch(storeHistorySelection(selection))
})

class ComponentsDiffsProcessor{
    getComponentsList(report) {
        const components = []
        const keys = []

        for (const entry of report.licensing.reports){
            for (const result of entry.results) {
                const version = !result.version.replace(/-/g,"").length? null: result.version
                keys.push(result.library.name+(version?" "+version:""))
                components.push(result.library.name)

            }
        }

        return {keys, components}
    }

    calculateComponentsDiffs(old, current){
        const currentComponents = this.getComponentsList(current)
        const oldComponents = this.getComponentsList(old)

        

        const diffs = {
            "plus": [],
            "minus": [],
            "versionChanges": []
        }



        const addedComponents = {keys:[], components:[]}
        const removedComponents = {keys:[], components:[]}

        const versionChanges = []


        for (let i = 0; i < oldComponents.keys.length ; i++){
            const entry = oldComponents.keys[i]
            const oldComponent = oldComponents.components[i]
            if ( !currentComponents.keys.includes(entry)){
                const index = currentComponents.components.indexOf(oldComponent)
                if(index>=0){
                    // versionChanges.push(entry + " ➔ "+ currentComponents.keys[index])
                    continue
                }

                removedComponents.keys.push(entry)
                removedComponents.components.push(oldComponents.components[i])
            }


        }

        const pickedNames = []

        for (let i = 0; i < currentComponents.keys.length ; i++){
            const entry = currentComponents.keys[i]
            const currentComponent = currentComponents.components[i]
            if ( !oldComponents.keys.includes(entry)){
                const indexes = oldComponents.components.reduce((indexes, current, index)=>{
                    if(current===currentComponent){
                        indexes.push(index)
                    }
                    return indexes
                },[]).filter(current=>!currentComponents.keys.includes(oldComponents.keys[current]))
                let skip = false
                if (indexes.length){
                    for(let index of indexes){

                        if(index>=0){
                            const key = oldComponents.keys[index]
                            if(pickedNames.includes(key)) continue
                            versionChanges.push( key+" ➔ "+entry)
                            pickedNames.push(key)
                            skip=true
                            break
                        }
                    }
    
                }


                if (skip) continue
                
                addedComponents.keys.push(entry)
                addedComponents.components.push(currentComponents.components[i])
            }
        }






        diffs.plus = addedComponents.keys
        diffs.minus = removedComponents.keys
        diffs.versionChanges = versionChanges


        // for (let i = 0; i < oldComponents.components.length ; i++) {
        //     const entry = oldComponents.components[i]

        //     if(currentComponents.components.includes(entry)){
        //         const index = currentComponents.components.indexOf(entry)
        //         const key = currentComponents.keys[index]
        //         const oldKey = oldComponents.keys[i]
        //         if(key !== oldKey) {
        //             diffs.versionChanges.push(oldKey + " ➔ "+ key)
        //             pickedNames.push(entry)
        //         }
        //     }
        // }

        // for (let i = 0; i < currentComponents.components.length ; i++) {
        //     const entry = currentComponents.components[i]

        //     if(oldComponents.components.includes(entry) && !pickedNames.includes(entry)){
        //         const index = oldComponents.components.indexOf(entry)
        //         const key = currentComponents.keys[i]
        //         const oldKey = oldComponents.keys[index]
        //         if(key !== oldKey) {
        //             diffs.versionChanges.push(oldKey + " ➔ "+ key)
        //             pickedNames.push(entry)
        //         }
        //     }
        // }


        // for (const entry of oldComponents.keys) {
        //     if(!currentComponents.keys.includes(entry) && !pickedNames.includes(entry.split(" ")[0]) ) {
        //         diffs.minus.push(entry)
        //     }
        // }
        // for (const entry of currentComponents.keys) {
        //     if(!oldComponents.keys.includes(entry) && !pickedNames.includes(entry.split(" ")[0]) ) {
        //         diffs.plus.push(entry)
        //     }
        // }
        
        return diffs
        
    }
}


class SecurityDiffsProcessor{
    getAdvisories(report){
        const advisories = []
        const keys = []
        const excluded = []
        for (const assessment of report.security.assessments){
            for (const result of assessment.reports) {
                for(const advice of result.advices){
                    if(advice.severity==="NONE" || advice.severity==="SUGGEST") continue
                    if(advice.exclusions){
                        excluded.push({advice, library: result.dependency.library.name, version: result.dependency.version, language: assessment.language})
                        continue
                    } 
                    keys.push(advice.id+"|"+result.dependency.library.name+"|"+assessment.language)
                    advisories.push({exclusion: false, advice: advice.id, severity: advice.severity, cve: advice.cve, library: result.dependency.library.name, version: result.dependency.version, language: assessment.language })
                }
            }
        }
        return {advisories, keys, excluded}
    }
    getSecurityExclusions(report, excluded){
        const exclusions = []
        const keys = []

        for (const exclusion of report.exclusions.security.advices){
            for(const entry of excluded){
                
                if (entry.advice.exclusions.includes(exclusion.id)){
                    exclusions.push({
                        exclusion: true, advice: entry.advice.id, severity: entry.advice.severity, cve: entry.advice.cve, library: entry.library, version: entry.version, language: entry.language
                    })
                    keys.push(entry.advice.id+"|"+exclusion.id+"|"+entry.library+"|"+entry.language)
                }
            }
        }
        for (const exclusion of report.exclusions.security.libraries){
            for(const entry of excluded){
                if (entry.advice.exclusions.includes(exclusion.id)){
                    exclusions.push({
                        exclusion: true, advice: entry.advice.id, severity: entry.advice.severity, cve: entry.advice.cve, library: entry.library, version: entry.version, language: entry.language
                    })
                    keys.push(entry.advice.id+"|"+exclusion.id+"|"+entry.library+"|"+entry.language)
                }
            }
        }
        for (const exclusion of report.exclusions.security.cves){
            for(const entry of excluded){

                if (entry.advice.exclusions.includes(exclusion.id)){
                    exclusions.push({
                        exclusion: true, advice: entry.advice.id, severity: entry.advice.severity, cve: entry.advice.cve, library: entry.library, version: entry.version, language: entry.language
                    })
                    keys.push(entry.advice.id+"|"+exclusion.id+"|"+entry.library+"|"+entry.language)
                }
            }
        }
        return { exclusions, keys }
    }
    find(entry, list){
        return list.includes(entry)
    }
    crossFind(entry, list){
        return list.filter(current=>current.includes(entry)).length > 0
    }
    findInComponentsList(entry, list){
        return list.includes(entry.library + " " + entry.version)
    }
    findInComponentUpdatedList(entry, list){
        return list.filter(current=>current.includes(entry.library + " " + entry.version)).length > 0
    }
    
    
    getAdvisoriesList(old, current, componentsDiffs){
        const oldList = this.getAdvisories(old)
        const currentList = this.getAdvisories(current)

        const oldExclusions = this.getSecurityExclusions(old, oldList.excluded)
        const currentExclusions = this.getSecurityExclusions(current, currentList.excluded)

        const diffs = {
            plus: [],
            minus: []
        }

        for (let i = 0; i < oldExclusions.keys.length; i++){
            const key = oldExclusions.keys[i]
            const entry = oldExclusions.exclusions[i]

            const removed = !this.find(key, currentExclusions.keys ) 
            const componentRemoved = this.findInComponentsList(entry, componentsDiffs.minus)
            const componentUpdated = this.findInComponentUpdatedList(entry, componentsDiffs.versionChanges)
            if (componentUpdated || componentRemoved) continue
            if(removed) diffs.minus.push(entry)
        }

        for (let i = 0; i < currentExclusions.keys.length; i++){
            const key = currentExclusions.keys[i]
            const entry = currentExclusions.exclusions[i]
            
            const added = !this.find(key, oldExclusions.keys )
            const componentUpdated = this.findInComponentUpdatedList(entry, componentsDiffs.versionChanges)

            if(componentUpdated) continue
            if(added) diffs.plus.push(entry)
        }


        for (let i = 0; i < oldList.keys.length; i++){
            const key = oldList.keys[i]
            const entry = oldList.advisories[i]

            const removed = !this.find(key, currentList.keys )
            const componentUpdated = this.findInComponentUpdatedList(entry, componentsDiffs.versionChanges)
            if (componentUpdated) continue
            if(removed) diffs.minus.push(entry)
        }
        for (let i = 0; i < currentList.keys.length; i++){
            const key = currentList.keys[i]
            const entry = currentList.advisories[i]

            const added = !this.find(key, oldList.keys )
            const componentUpdated = this.findInComponentUpdatedList(entry, componentsDiffs.versionChanges)
            if (componentUpdated) continue
            if(added) diffs.plus.push(entry)
        }
        
        

        return diffs
    }
}

class StabilityDiffsProcessor{
    getOutdated(report, componentsDiffs){
        const outdated = []
        const keys = []
        const excluded = []
        for (const stabReport of report.stability.reports){
            for (const version of stabReport.versions) {

                if (!version.newPatchVersionAvailable) continue
                if(version.exclusions.length) {
                    excluded.push({exclusions: version.exclusions, library: version.name, version: version.version, language: stabReport.language})
                    continue
                }
                let reason = false
                if(componentsDiffs){
                    if(componentsDiffs.minus.includes(version.name+" "+version.version)){
                        reason = "removed"
                    }
                    else if(componentsDiffs.versionChanges.join("; ").includes(version.name+" "+version.version)){
                        reason = "updated"
                    }
                    
                }
                keys.push(version.name+"|"+version.version+"|"+stabReport.language)
                outdated.push({exclusion: false, library: version.name, version: version.version, language: stabReport.language, patch: version.latestPatch, reason})
            }
        }

        return {outdated, keys, excluded}
    }
    getStabilityExclusions(report, excluded){
        const exclusions = []
        const keys = []

        for (const exclusion of report.exclusions.stability.libraries){
            for(const entry of excluded){
                if (entry.exclusions.includes(exclusion.id)){
                    exclusions.push({
                        exclusion: true, library: entry.library, version: entry.version, language: entry.language, patch: entry.latestPatch
                    })
                    keys.push(exclusion.id+"|"+entry.library+"|"+entry.version+"|"+entry.language)
                }
            }
        }
        return { exclusions, keys }
    }

    find(entry, list){
        return list.includes(entry)
    }
    crossFind(entry, list, exclusions=false){
        if(exclusions) {
            return list.filter(current=>entry.includes(current)).length > 0
        }
        return list.filter(current=>current.includes(entry)).length > 0
    }
    findInComponentsList(entry, list){
        return list.includes(entry.library + " " + entry.version)
    }
    findInComponentUpdatedList(entry, list){
        return list.filter(current=>current.includes(entry.library + " " + entry.version)).length > 0
    }



    getOutdatedList(old, current, componentsDiffs){
        
        const oldList = this.getOutdated(old, componentsDiffs)
        const currentList = this.getOutdated(current)

        const oldExclusions = this.getStabilityExclusions(old, oldList.excluded)
        const currentExclusions = this.getStabilityExclusions(current, currentList.excluded)

        const diffs = {
            plus: [],
            minus: []
        }


        for (let i = 0; i < oldList.keys.length; i++){
            const key = oldList.keys[i]
            const entry = oldList.outdated[i]
            const removed = !this.find(key, currentList.keys)

            const matchedInCurrentExclusions = this.crossFind(key, currentExclusions.keys)
            if(matchedInCurrentExclusions)continue
            
            if(removed) diffs.minus.push(entry)
        }

        for (let i = 0; i < currentList.keys.length; i++){
            const key = currentList.keys[i]
            const entry = currentList.outdated[i]
            const added = !this.find(key, oldList.keys)
            const matchedInOldExclusions = this.crossFind(key, oldExclusions.keys)
            if(matchedInOldExclusions) {
                entry.exclusionRemoved=true
            }

            if(added) diffs.plus.push(entry)
        }
        
        for (let i = 0; i < oldExclusions.keys.length; i++){
            const key = oldExclusions.keys[i]
            const entry = oldExclusions.exclusions[i]
            const removed = !this.find(key, currentExclusions.keys)
            const matchedInCurrentList = this.crossFind(key, currentList.keys, true)
            if(matchedInCurrentList) continue
            if(removed) diffs.minus.push(entry)
        }

        for (let i = 0; i < currentExclusions.keys.length; i++){
            const key = currentExclusions.keys[i]
            const entry = currentExclusions.exclusions[i]
            const added = !this.find(key, oldExclusions.keys)
            
            if(added) diffs.plus.push(entry)
        }

        return diffs
    }
}

class LicensingDiffsProcessor{
    getIssues(report){
        const issues = []
        const keys = []
        const excluded = []
        const all = []
        const allKeys = []
        for (const licReport of report.licensing.reports){
            
            for (const result of licReport.results) {
                const licenses = result.licenses.reduce((names, license)=>{names.push(license.name); return names},[])
                let policies = result.violations.reduce((names, policy)=>{names.push(policy.policyName); return names},[])

                const key = result.library.name+"|"+licReport.language
                const entry = {exclusion: false, library: result.library.name, version: result.version, language: licReport.language, licenses, policies}
                allKeys.push(key)
                all.push(entry)
                if (result.warnings.length + result.violations.length <= 0) continue
                if(result.exclusions.length) {
                    excluded.push({exclusions: result.exclusions, library: result.library.name, version: result.version, language: licReport.language, licenses, policies })
                    continue
                }
                keys.push(key)
                issues.push(entry)
            }
        }
        return {issues, keys, excluded, allKeys, all}
    }
    getLicensingExclusions(report, excluded){
        const exclusions = []
        const keys = []

        for (const exclusion of report.exclusions.licensing.libraries){
            for(const entry of excluded){
                if (entry.exclusions.includes(exclusion.id)){
                    exclusions.push({
                        exclusion: true, library: entry.library, version: entry.version, language: entry.language, licenses: entry.licenses, policies: entry.polcies
                    })
                    keys.push(exclusion.id+"|"+entry.library+"|"+entry.language)
                }
            }
        }
        return { exclusions, keys }
    }

    processLicensesChanges(entryA, entryB){
        const licenses = []
        for (const license of entryA.licenses) {
            if (!entryB.licenses.includes(license)){
                licenses.push(license)
            }
        }

        return licenses
    }
    processPoliciesChanges(entryA, entryB){
        const policies = []
        for (const policy of entryA.policies) {
            if (!entryB.policies.includes(policy)){
                policies.push(policy)
            }
        }

        return policies
    }


    getIssuesList(old, current){
        const oldList = this.getIssues(old)
        const currentList = this.getIssues(current)

        const oldExclusions = this.getLicensingExclusions(old, oldList.excluded)
        const currentExclusions = this.getLicensingExclusions(current, currentList.excluded)


        const diffs = {
            plus: [],
            minus: []
        }

        for (let i = 0; i < oldList.keys.length; i++){
            const key = oldList.keys[i]
            const entry = oldList.issues[i]

            if(!currentList.keys.includes(key)) diffs.minus.push(entry)
        }
        for (let i = 0; i < currentList.keys.length; i++){
            const key = currentList.keys[i]
            const entry = currentList.issues[i]

            if(!oldList.keys.includes(key) ) {

                const index = oldList.allKeys.indexOf(key)
                const otherEntry = oldList.all[index]
                const currentLicenses = entry.licenses.join(",")
                const otherLicenses = otherEntry && otherEntry.licenses? otherEntry.licenses.join(",") : ""
                const currentPolicies = entry.policies.join(",")
                const otherPolicies = otherEntry && otherEntry.policies? otherEntry.policies.join(",") : ""
                if(currentLicenses.length && otherLicenses.length && currentLicenses !== otherLicenses){
                    entry.licenses = this.processLicensesChanges(entry, otherEntry)
                    entry.diffLicenses = true
                }
                if(currentLicenses.length && !otherLicenses.length){
                    entry.diffLicenses = true
                }
                if(currentPolicies.length && otherPolicies.length && currentPolicies !== otherPolicies){
                    entry.policies = this.processPoliciesChanges(entry, otherEntry)
                    entry.diffPolicies = true
                }
                if(currentPolicies.length && !otherPolicies.length){
                    entry.diffPolicies = true
                }
                
                diffs.plus.push(entry)
            }
            
        }
        
        for (let i = 0; i < oldExclusions.keys.length; i++){
            const key = oldExclusions.keys[i]
            const entry = oldExclusions.exclusions[i]

            if(!currentExclusions.keys.includes(key)) diffs.minus.push(entry)
        }

        for (let i = 0; i < currentExclusions.keys.length; i++){
            const key = currentExclusions.keys[i]
            const entry = currentExclusions.exclusions[i]

            if(!oldExclusions.keys.includes(key)) diffs.plus.push(entry)
        }

        return diffs
    }
}

const Details = (props) => {

    const ComponentDiff = ({entry, which}) =>{
        return <p className={which}><span>{which ==="plus"? "+":"-"}</span>{entry}</p>
    
    }
    const SecurityDiff = ({entry, which}) =>{
        if (entry.exclusion){
            return which==="plus"?
                <p className="plus"><span>+</span>Added exclusion for {entry.severity} threat vulnerability introduced by {entry.library}:{entry.version} {entry.cve? `(${entry.cve})`: ""} </p> :
                <p className="minus"><span>-</span>Removed exclusion for {entry.severity} threat vulnerability introduced by {entry.library}:{entry.version} {entry.cve? `(${entry.cve})`: ""} </p>
        }
        return which==="plus"?
            <p className="minus"><span>+</span>{entry.severity} threat vulnerability introduced by {entry.library}:{entry.version} {entry.cve? `(${entry.cve})`: ""} </p> :
            <p className="plus"><span>-</span>Removed {entry.severity} threat vulnerability introduced by {entry.library}:{entry.version}  {entry.cve? `(${entry.cve})`: ""} </p>
    }

    const StabilityDiff = ({entry, which}) =>{
        if (entry.exclusion){
            return which==="plus"?
                <p className="plus"><span>+</span>Excluded outdated component {entry.library}:{entry.version} </p> :
                <p className="minus"><span>-</span>Removed Exclusion for outdated component {entry.library}:{entry.version} </p>
        }
        return which==="plus"?
            <p className="minus"><span>+</span>{entry.library}:{entry.version} has a new patch release available ({entry.patch}) {entry.exclusionRemoved? "- A mitigation has been removed":""}</p> :
            <p className="plus"><span>-</span>Outdate component {entry.library}:{entry.version} has been {entry.reason}  </p>
    }

    const LicensingDiff = ({entry, which}) =>{
        if (entry.exclusion){
            return which==="plus"?
                <p className="plus"><span>+</span>Excluded {entry.library}:{entry.version} with licensing issue</p> :
                <p className="minus"><span>-</span>Removed exclusion for component {entry.library}:{entry.version} with licensing issue</p>
            }

        if (which ==="plus"){
            if (entry.diffLicenses){
                return (
                    <p className="minus"><span>+</span>{entry.library}:{entry.version}&nbsp;
                        {entry.licenses.length>1? 
                            "has "+entry.licenses.length+" new licenses ("+entry.licenses.join(", ") +")" : 
                            "has 1 new license ("+entry.licenses.join(", ") +")" 
                        }
                        {entry.policies.length>1? 
                            " with "+entry.policies.length+" applied polcies ("+entry.policies.join(", ") +")" : 
                            " with 1 applied policy ("+entry.policies.join(", ") +")"
                        }
                    </p>
                )
            }
            if (!entry.diffLicenses && entry.diffPolicies){
                return (<p className="minus"><span>+</span>{entry.policies.length>1? 
                    "Applied "+entry.policies.length+" new polcies ("+entry.policies.join(", ") +")" : 
                    "Applied 1 new policy ("+entry.policies.join(", ") +")"
                }
                &nbsp;which affects&nbsp;
                {
                    entry.licenses.length>1?
                        `at least one of ${entry.library}:${entry.version} licenses` : 
                        `${entry.library}:${entry.version} license`
                }
                
                </p>)
            }

            if (!entry.diffLicenses && !entry.diffPolcies){
                return <p className="minus"><span>+</span>New licensing issue for {entry.library}:{entry.version} </p>
            }

        }
        else{
            return <p className="plus"><span>-</span>Remove licensing issue for {entry.library}:{entry.version} </p>
        }
        
    }

    const Components = () =>(
        <React.Fragment>
            <p className="mb-0 font-weight-bold">COMPONENTS</p>
            { props.data.componentsDiffs.plus.length + props.data.componentsDiffs.minus.length + props.data.componentsDiffs.versionChanges.length > 0 ?
                <div id="components-diffs" >
                    { props.data.componentsDiffs.plus.map((entry, i)=><ComponentDiff key={"componentdiff-"+i+entry.library+entry.version} entry={entry} which={"plus"} />)}
                    { props.data.componentsDiffs.versionChanges.map((entry, i)=><ComponentDiff key={"componentdiff-"+i+entry.library+entry.version} entry={entry} which={"plus"} />)}
                    { props.data.componentsDiffs.minus.map((entry, i)=><ComponentDiff key={"componentdiff-"+i+entry.library+entry.version} entry={entry} which={"minus"} />)}
                </div> :
                <p className="mb-2 " >No components have changed from the previous report.</p>
            }
        </React.Fragment>
    )

    const Security = () =>(
        !props.data.securityDiffs ? "" :
        <React.Fragment>
            <p className="mb-0 font-weight-bold">SECURITY</p>
            { props.data.securityDiffs.plus.length + props.data.securityDiffs.minus.length >0 ?
                <div id="security-diffs">
                    { props.data.securityDiffs.plus.map((entry, i)=><SecurityDiff key={"securitydiff-"+i+entry.library+entry.version} entry={entry} which={"plus"} />) }
                    { props.data.securityDiffs.minus.map((entry, i)=><SecurityDiff key={"securitydiff-"+i+entry.library+entry.version} entry={entry} which={"minus"} />) }
                </div> :
                <p className="mb-2 " >Nothing has changed in the security section.</p>
            }
        </React.Fragment>
    )

    const Stability = () =>(
        !props.data.stabilityDiffs ? "" :
        <React.Fragment>
            <p className="mb-0 font-weight-bold">STABILITY</p>
            { props.data.stabilityDiffs.plus.length + props.data.stabilityDiffs.minus.length >0 ?
                <div id="stability-diffs">
                    { props.data.stabilityDiffs.plus.map((entry, i)=><StabilityDiff key={"stabilitydiff-"+i+entry.library+entry.version} entry={entry} which={"plus"} />) }
                    { props.data.stabilityDiffs.minus.map((entry, i)=><StabilityDiff key={"stabilitydiff-"+i+entry.library+entry.version} entry={entry} which={"minus"} />) }
                </div> :
                <p className="mb-2 " >Nothing has changed in the stability section.</p>
            }
        </React.Fragment>
    )

    const Licensing = () =>(
        !props.data.licensingDiffs ? "" :
        <React.Fragment>
            <p className="mb-0 font-weight-bold">LICENSING</p>
            { props.data.licensingDiffs.plus.length + props.data.licensingDiffs.minus.length >0 ?
                <div id="stability-diffs">
                    { props.data.licensingDiffs.plus.map((entry, i)=><LicensingDiff key={"licensingdiff-"+i+entry.library+entry.version} entry={entry} which={"plus"} />) }
                    { props.data.licensingDiffs.minus.map((entry, i)=><LicensingDiff key={"licensingdiff-"+i+entry.library+entry.version} entry={entry} which={"minus"} />) }
                </div> :
                <p className="mb-2 " >Nothing has changed in the stability section.</p>
            }
        </React.Fragment>
    )

    const Diffs = () => {

        if (!props.data){
            return (
                <p className="mb-2 " >This is either the first report or there are no information available for the previous report</p>
            )
        }
        return (
            <React.Fragment>
                <Components />
                <hr/>
                <Security />
                <Stability />
                <Licensing />
            </React.Fragment>
        )
    }

    return (
        <React.Fragment>
            <Diffs />
        </React.Fragment>
    )
}



class HistoryDetails extends React.Component{

    constructor(props){
        super(props)
        this.state = {ready: false, data: {}}
        this.previousReport = null
    }


    async loadReport(uuid){
        const accessToken = window.AuthUtils.getTokenFromLocalStorage()
        const report = new Report({"Authorization": "Bearer "+accessToken})
        return await report.get(this.props.pid, uuid)
    }

    async processReports(){
        const reportUUID = this.props.uuid

        let oldReportUUID = null
        let report = this.props.report , oldReport = null

        let foundMatchingReport = false

        
        const {history,chart} = this.props.historyData

        for( let i = 0; i < history.length ; i++ ){
            if(foundMatchingReport) {
                oldReportUUID = history[i].uuid
                break
            }
            if (history[i].uuid === reportUUID) {
                foundMatchingReport = true
            }
        }

        oldReport = {
            security:{assessments:[]},
            stability:{reports: []},
            licensing: {reports: []},
            exclusions: {
                security:{
                    advices:[], libraries: [], cves: []
                }, 
                stability: {
                    libraries: []
                },
                licensing: {
                    libraries: []
                }
            }
        }

        this.previousReport = oldReportUUID
        if(oldReportUUID){
            oldReport =  await this.loadReport(oldReportUUID)
        }
        
        let currentReport = null
        if(reportUUID ===report.uuid){
            currentReport = report
        }
        else{
            currentReport = await this.loadReport(reportUUID)
        }

        const componentsDiffsProcess = new ComponentsDiffsProcessor()
        const componentsDiffs = componentsDiffsProcess.calculateComponentsDiffs(oldReport, currentReport)
        const data = {componentsDiffs}
        if(chart ==="security"){
            const securityDiffsProcessor = new SecurityDiffsProcessor()
            const securityDiffs = securityDiffsProcessor.getAdvisoriesList(oldReport, currentReport, componentsDiffs)
            data.securityDiffs = securityDiffs
        }
        if(chart ==="stability"){
            const stabilityDiffsProcessor = new StabilityDiffsProcessor()
            const stabilityDiffs = stabilityDiffsProcessor.getOutdatedList(oldReport, currentReport, componentsDiffs)
            data.stabilityDiffs = stabilityDiffs
        }
        if(chart ==="licensing"){
            const licensingDiffsProcessor = new LicensingDiffsProcessor()
            const licensingDiffs = licensingDiffsProcessor.getIssuesList(oldReport, currentReport, componentsDiffs)
            data.licensingDiffs =licensingDiffs
        }


        this.setState({
            ready: true, data, oldest: !oldReportUUID
        })

    }

    componentDidMount(){
        this.processReports()
    }



    render(){
        const openReport = ()=>{
            this.props.loadPage(this.props.historyData.selected, this.props.report.uuid === this.props.historyData.selected)
        }
        const openPreviousReport = ()=>{
            this.props.setHistoryData({selected: this.previousReport})
            setTimeout(()=>{
                openReport()
            },300)

        }

        return (
            <div className="modal fade" id="history-details" tabIndex="-1" role="dialog" aria-modal="true" >
                <div className="modal-dialog modal-xl modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">Reports differences</h4>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                        </div>

                        <div className="modal-body">

                            { this.state.ready ?  
                                <Details data={this.state.data} /> : 
                                <div className="center-block d-flex justify-content-center align-items-center">
                                    <div className="spinner-border text-primary" role="status">
                                        <span className="sr-only">Loading...</span>
                                    </div>
                                </div>
                            }
                            
                        </div>

                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-dismiss="modal">Cancel</button>
                            <button type="button" className="btn btn-primary" id="exclude-confirm-submit" data-dismiss="modal" onClick={openReport}>See report</button>
                            {/* {!this.state.oldest?<button type="button" className="btn btn-primary" id="exclude-confirm-submit" data-dismiss="modal" onClick={openPreviousReport}>See previous report</button> : ""} */}
                        </div>
                    </div>
                </div>
            </div>
        )

    }
}


export default connect(mapStateAsProps, mapDispatchAsProps)(HistoryDetails)